import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';
import { NtExperienceAndHospital } from '../../../../../../shared/interfaces/nt-experienceAndHospitals';


@Component({
  selector: 'app-n-hospitals-and-experiences',
  imports: [CommonModule],
  templateUrl: './n-hospitals-and-experiences.component.html',
  styleUrl: './n-hospitals-and-experiences.component.css'
})
export class NHospitalsAndExperiencesComponent implements OnInit{
  public medicineId: number = 0;
  public companyId: number = 0;
  public countryId: number = 1;

  isLoading=false;
  experienceAndHospitals!: NtExperienceAndHospital;

constructor(private dataService:DataService, private us:DmtUtilityService){}

ngOnInit(): void {
  this.isLoading=true;
  this.getSessionVariables();
  this.getNationalExperienceAndHospitalInfo();
}

formatNumber(value: number): string {
  return new Intl.NumberFormat('it-IT').format(value);
}

getNationalExperienceAndHospitalInfo() {
  this.dataService
    .getNationalExperienceAndHospitalInfo(this.medicineId, this.countryId)
    .subscribe({
      next: (data) => {
     // we can simulate empty data with
        //  data=[]
        this.experienceAndHospitals = {
          hosptialsTotalNumber: data?.hosptialsTotalNumber ?? 0,
          experienceTotal: data?.experienceTotal ?? 0
        };
        this.isLoading = false;
      },
      error: () => {
        this.experienceAndHospitals = {
          hosptialsTotalNumber: 0,
          experienceTotal: 0
        };
        this.isLoading = false;
      }
    });
}

  getSessionVariables() {
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
  }

}

